var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f8c9e40e0ad1b24d19d425b1d685420a2f3cb41f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["xreal-com@xreal-inc"]={id:"f8c9e40e0ad1b24d19d425b1d685420a2f3cb41f"};
      